export default Object.freeze({
  SPECIALITY: {
    ECG: 19,
    RAIOX: 25,
    RAIOXOIT: 53,
    EEG: 20,
    ESPIRO: 22,
    HOLTER: 23,
    MAMOGRAFIA: 110,
    DENSITOMETRIA: 113,
    ACUIDADE: 16,
    MAPA: 24,
    ESFORCO_CARDIOPULMONAR: 99,
    TESTE_ERGOMETRICO: 75,
    TOMOGRAFIA: 87,
    TC_SEIOS_DA_FACE: 108,
    TC_PESCOCO: 149,
    TC_CRANIO: 150,
    TC_TORAX: 153,
    TC_ABDOME_SUPERIOR: 164,
    TC_OUVIDO: 166,
    TC_FACE: 167,
    TC_COLUNA_LOMBAR: 186,
    TC_BACIA: 191,
    TC_COLUNA_CERVICAL: 193,
    UROTOMOGRAFIA: 195,
    TC_QUADRIL_ESQUERDO: 225,
    TC_ABDOME_TOTAL: 226,
    TC_ABDOME_TOTAL_COM_CONTRASTE: 376,
    TC_PELVE: 227,
    TC_COLUNA_DORSAL: 228,
    TC_SELA_TURCICA: 229,
    TC_OUVIDOS_MASTOIDES: 230,
    TC_ABDOME_INFERIOR: 234,
    TC_TORNOZELO_ESQUERDO: 235,
    TC_COLUNA_TORACICA: 236,
    TC_PE_ESQUERDO: 237,
    TC_PE_DIREITO: 238,
    TC_MASTOIDES: 239,
    TC_PERNAS: 244,
    TC_PERNA_ESQUERDA: 245,
    TC_PERNA_DIREITA: 246,
    RESSONANCIA: 109,
    RM_HIPOFISE: 119,
    RM_COLUNA_CERVICAL: 120,
    RM_CRANIO: 121,
    RM_ORBITAS: 122,
    RM_PROSTATA: 123,
    RM_PELVE: 124,
    RM_OUVIDO: 127,
    RM_ABDOME_TOTAL: 128,
    RM_ABDOME_SUPERIOR: 129,
    RM_JOELHO_DIREITO: 130,
    RM_JOELHO_ESQUERDO: 131,
    COLANGIO_POR_RM: 132,
    RM_COLUNA_DORSAL: 133,
    RM_COLUNA_LOMBAR: 134,
    RM_PESCOCO: 135,
    ANGIO_RM_CERVICAL: 136,
    ENTERO_POR_RM: 137,
    RM_TORNOZELO_DIREITO: 138,
    RM_BACIA: 139,
    RM_PE_ESQUERDO: 140,
    RM_ATM: 141,
    RM_OMBRO_DIREITO: 142,
    RM_TORNOZELO_ESQUERDO: 143,
    RM_PLEXO_BRAQUIAL_DIREITO: 145,
    ANGIO_RM_CRANIO: 146,
    RM_OMBRO_ESQUERDO: 147,
    RM_PE_DIREITO: 148,
    RM_PUNHO_DIREITO: 151,
    RM_QUADRIL: 152,
    RM_MAMAS: 154,
    RM_COLUNA_TORACICA: 155,
    RM_COTOVELO_DIREITO: 156,
    RM_COTOVELO_ESQUERDO: 157,
    RM_FACE: 158,
    RM_PLEXO_BRAQUIAL_ESQUERDO: 159,
    RM_PUNHO_ESQUERDO: 160,
    URO_RM: 161,
    RM_TORAX: 163,
    RM_CRANIO_ESPECTRO: 171,
    ANGIO_RM_AORTA_TORACICA: 179,
    RM_MAO_DIREITA: 180,
    RM_MAO_ESQUERDA: 181,
    RM_PERNA_DIREITA: 182,
    RM_PERNA_ESQUERDA: 183,
    RM_BRACO_DIREITO: 184,
    RM_BRACO_ESQUERDO: 185,
    RM_COXA_DIREITA: 187,
    RM_COXA_ESQUERDA: 188,
    RM_QUADRIL_DIREITO: 189,
    RM_QUADRIL_ESQUERDO: 190,
    RM_SACROILIACAS: 192,
    RX_ARCOS_COSTAIS: 17,
    RX_FEMUR: 26,
    RX_ABDOME: 27,
    RX_ANTEBRACO: 28,
    RX_BACIA: 29,
    RX_BRACO: 30,
    RX_CLAVICULA: 31,
    RX_COLUNA_CERVICAL: 32,
    RX_COLUNA_DORSAL: 33,
    RX_COLUNA_LOMBO_SACRA: 34,
    RX_COTOVELO: 35,
    RX_COTOVELO_DIREITO: 36,
    RX_COTOVELO_ESQUERDO: 37,
    RX_COXA: 38,
    RX_CRANIO: 39,
    RX_JOELHO: 40,
    RX_MAO: 41,
    RX_MAO_DIREITA: 42,
    RX_MAO_ESQUERDA: 43,
    RX_OMBRO_DIREITO: 44,
    RX_OMBRO_ESQUERDO: 45,
    RX_OMBROS: 46,
    RX_PE: 47,
    RX_PERNA: 48,
    RX_PUNHO: 49,
    RX_QUADRIL: 50,
    RX_SEIOS_DA_FACE: 51,
    RX_TORAX: 52,
    RX_TORAX_PA_LEITURA_OIT: 53,
    RX_TORNOZELO: 54,
    RX_COLUNA_CERVICO_DORSAL: 56,
    RX_JOELHO_ESQUERDO: 57,
    RX_JOELHO_DIREITO: 58,
    RX_PUNHO_DIREITO: 59,
    RX_PUNHO_ESQUERDO: 60,
    RX_CAVUM: 61,
    RX_OSSOS_DA_FACE: 62,
    RX_QUADRIL_DIREITO: 63,
    RX_QUADRIL_ESQUERDO: 64,
    RX_ESCAPULA_DIREITA: 65,
    RX_ESCAPULA_ESQUERDA: 66,
    RX_PATELA: 67,
    RX_PELVE: 68,
    RX_COLUNA_TORACO_LOMBAR: 69,
    RX_PE_DIREITO: 70,
    RX_PE_ESQUERDO: 71,
    RX_SACRO_COCCIX: 72,
    RX_COXO_FEMORAL: 73,
    RX_COLUNA_TORACICA: 74,
    RX_COLUNA_DORSO_LOMBAR: 76,
    RX_UMERO: 77,
    RX_CALCANEO: 78,
    RX_CALCANEO_DIREITO: 79,
    RX_CALCANEO_ESQUERDO: 80,
    RX_CLAVICULA_DIREITA: 81,
    RX_CLAVICULA_ESQUERDA: 82,
    RX_MANDIBULA_DIREITA: 85,
    RX_MANDIBULA_ESQUERDA: 86,
    RX_TORNOZELO_DIREITO: 88,
    RX_TORNOZELO_ESQUERDO: 89,
    RX_FEMUR_DIREITO: 90,
    RX_FEMUR_ESQUERDO: 91,
    RX_FIBULA_TIBIA_DIREITA: 92,
    RX_FIBULA_TIBIA_ESQUERDA: 93,
    RX_ANTEBRACO_DIREITO: 94,
    RX_ANTEBRACO_ESQUERDO: 95,
    RX_PERNA_ESQUERDA: 96,
    RX_PERNA_DIREITA: 97,
    RX_MAOS_PUNHOS_IDADE_OSSEA: 98,
    RX_COLUNA_LOMBAR: 100,
    RX_COCCIX: 101,
    RX_COSTELA_ESQUERDA: 102,
    RX_COSTELA_DIREITA: 103,
    RX_SELA_TURCICA: 104,
    RX_5O_DEDO_DIREITO: 105,
    RX_BRACO_DIREITO: 106,
    RX_BRACO_ESQUERDO: 107,
    RX_PATELA_JOELHO_DIREITO: 111,
    RX_PATELA_JOELHO_ESQUERDO: 112,
    RX_MEMBRO_INFERIOR_DIREITO: 115,
    RX_MEMBRO_INFERIOR_ESQUERDO: 116,
    RX_UMERO_DIREITO: 117,
    RX_UMERO_ESQUERDO: 118,
    RX_DEDO_MAO_ESQUERDA: 162,
    RX_DEDO_PE_DIREITO: 165,
    RX_ATM: 172,
    RX_ESCANOMETRIA: 173,
    RX_COLUNA_TOTAL: 174,
    RX_ESTTERNO: 175,
    RX_SACRO_ILIACAS: 176,
    RX_COXO_FEMURAL_DIREITO: 177,
    RX_COXO_FEMURAL_ESQUERDO: 178,
    RX_1O_DEDO_DIREITO: 194,
    RX_AXIAL_HIRTZ: 196,
    RX_ARCOS_ZIGOMATICOS: 200,
    RX_DEDO_PE_ESQUERDO: 201,
    RX_OSSOS_NASAIS: 202,
    RX_ARCOS_COSTAIS_DIREITOS: 203,
    RX_ARCOS_COSTAIS_ESQUERDOS: 205,
    RX_CINTURA_ESCAPULAR_ESQUERDA: 206,
    RX_CINTURA_ESCAPULAR_DIREITA: 207,
    RX_ESTTERNO_DIREITO: 208,
    RX_ESTTERNO_ESQUERDO: 209,
    RX_DEDO_MAO_DIREITA: 211,
    RX_ABDOME_AGUDO: 215,
    RX_FIBULA_TIBIA: 216,
    RX_DEDO_MAO: 217,
    RX_ATM_DIREITA: 219,
    RX_ATM_ESQUERDA: 220,
    RX_DEDO_PE: 221,
    RX_ESCAPULA: 222,
    RX_COLUNA_PARA_ESCOLIOSE: 223,
    RX_COLUNA_LOMBO_SACRA_DINAMICA: 224,
    RAIOX_APICE_LORDOTICA: 232,
    RX_APICE_LORDOTICA: 233,
    RX_CINTURA_ESCAPULAR: 240,
    RX_MEMBROS_INFERIORES: 241,
    RX_COSTELA: 242,
    RX_MANDIBULA: 243,
    RX_PANORAMICO_MEMBROS_INFERIORES: 247,
    RX_DAS_MAOS: 248,
    ULTRASSONOGRAFIA_DO_OMBRO: 55
  },
  series: {
    CHEST: 'CHEST',
    ABDOMEN: 'ABDOMEN',
    PELVIS: 'PELVIS'
  },
  STATUS: {
    CRIADO: 5,
    LAUDANDO: 9,
    LAUDO_LIBERADO: 10,
    AGUARDANDO_OBSERVACAO: 18,
    AGUARDANDO_LAUDO: 22,
    AGUARDANDO_INFORMACAO: 26,
    ANALISANDO: 33,
    AGUARDANDO_RETIFICACAO: 41,
    RETIFICANDO: 43,
    AGUARDANDO_REVISAO_HOLTER: 51,
    REPETIR: 95,
    CANCELADO: 99,
    PENDENCIAS: 300
  },
  REPORT_STATUS: {
    NAO_SELECIONADO: 0,
    NORMAL: 1,
    ALTERADO: 2,
    REPETIR: 9
  },
  ROLES: {
    ANALYST: 'analyst',
    PHYSICIAN: 'physician',
    SOURCE: 'source'
  },
  PHYSICIAN_ACTIVITY_ORIGIN: {
    LAUDAR_RADIO: 1,
    LAUDAR: 2
  },
  TRANSLATION: {
    STATUS: {
      10: 'released_report',
      18: 'waiting_observation',
      22: 'waiting_report',
      26: 'waiting_information',
      33: 'analyzing',
      95: 'repeat',
      300: 'pendencies'
    }
  },
  CATEGORY: {
    XRAY: 1,
    TOMOGRAFIA: 6,
    ULTRASSONOGRAFIA: 8,
    RESSONANCIA: 9,
    MAMOGRAFIA: 10
  },
  DICOM_PLUS_STATUS:{
    PENDENTE: 0,
    REVISADO: 1,
    EXAME_CRIADO: 2,
    FALHA: 3,
    EXPIRADO: 4,
    DELETADO: 5,
    CANCELADO: 99,
  },
  DICOM_PLUS_TIPO_ANEXO: {
    EXAME_ANTERIOR: 1,
    ANAMNESE: 2,
    LAUDO_ANTERIOR: 3,
    PEDIDO_MEDICO: 4,
    EXAME_CRIADO: 5,
  },
  DICOM_PLUS_FONTE_CABECALHO_TAG: {
    CPF: 1,
    DATA_LAUDO: 2,
    IDADE: 3,
    OBSERVACOES: 4,
    ATENDIMENTO: 5,
    PACIENTE: 6,
  },
  DICOM_PLUS_PRIORIDADE: {
    ROTINA: 1,
    URGENCIA: 2,
    EMERGENCIA: 3,
  },
  DICOM_PLUS_MODALIDADE:{
    CR: "CR",
    DO: "DO",
    DX: "DX",
    MG: "MG",
    RM: "RM",
    TC: "TC",
    US: "US",
  },
  STATUS_BIT: {
    INATIVO: '0',
    ATIVO: '1'
  },
  DICOM_PLUS_MODALIDADE_ALIAS: {
    MR: 'RM',
    RM: "RM",
    CT: 'TC',
    TC: 'TC',
    RC: "CR",
    CR: 'CR',
    DX: "DX",
    MG: "MG",
    US: "US",
  },
  TIPO_AVALIACAO_ONCOLOGIA:{
    DESCOBERTA: {
      id: 1,
      description: 'Descoberta'
    },
    ESTADIAMENTO_INICIAL: {
      id: 2,
      description: 'Estadiamento inicial'
    },
    RESPOSTA: {
      id: 3,
      description: 'Resposta'
    },
    RESTADIAMENTO: {
      id: 4,
      description: 'Restadiamento'
    },
    SEGMENTO: {
      id: 5,
      description: 'Segmento'
    },
    COMPLICACAO: {
      id: 6,
      description: 'Complicação'
    },
  },
  DIAGNOSTICO_HIPOTESTE: {
    SITIO_PRIMARIO: {
      id: 1,
      description: 'Sítio Primário'
    },
    NEOPLASIA_CONHECIDA: {
      id: 2,
      description: 'Neoplasia Conhecida'
    },
    HIPOTESTE_DIAGNOSTICA: {
      id: 3,
      description: 'Hipotese Diagnóstica'
    },
  }
})
